module.exports = __webpack_public_path__ + "static/media/logo.d963b088.svg";